import request from "root/js/request";

export const getWbUserDisabledNotifications = async () => {
  const response = await request({
    url: `/monitoring/wb_user_disabled_notification/`,
    method: "get",
  });
  return response.data;
};

export const postWbUserDisabledNotifications = async ({
  spp_increase = false,
  analytics = false,
  spp_decrease = false,
  spp_same = false,
  blogger_monitoring_is_changed = false,
  blogger_monitoring_is_not_changed = false,
  ...rest
}) => {
  const response = await request({
    url: `/monitoring/wb_user_disabled_notification/`,
    method: "post",
    data: {
      spp_increase,
      spp_decrease,
      spp_same,
      analytics,
      blogger_monitoring_is_changed,
      blogger_monitoring_is_not_changed,
      ...rest,
    },
  });
  return response.data;
};
